import { onMounted, ref } from 'vue'
import type { Route } from 'vue-router'
import { brand } from '@/config/brands'
import { STORAGE_READER_TABOOLA_GUIDE_SHOWN } from '@/constants'

const READER_TABOOLA_GUIDE_BRANDS = new Set<string>(['storyella', 'rocnovel'])

function getQueryValue(value: Route['query'][string]) {
  return Array.isArray(value) ? value[0] : value
}

export function useReaderTaboolaGuide(route: Route) {
  const showReaderTaboolaGuide = ref(false)

  onMounted(() => {
    if (!READER_TABOOLA_GUIDE_BRANDS.has(brand))
      return

    if (getQueryValue(route.query.utm_source) !== 'taboola')
      return

    if (localStorage.getItem(STORAGE_READER_TABOOLA_GUIDE_SHOWN))
      return

    showReaderTaboolaGuide.value = true
    localStorage.setItem(STORAGE_READER_TABOOLA_GUIDE_SHOWN, '1')
  })

  return {
    showReaderTaboolaGuide,
  }
}
